import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicModal, YesNoView } from 'core/components';

function BaasicConfirmModalTemplate({ modalParams }) {
    return (
        <BaasicModal modalParams={modalParams} className="modal__content modal--confirmation">
            <YesNoView
                message={modalParams.data.message}
                onConfirm={modalParams.onConfirm}
                onCancel={modalParams.onCancel}
                loading={modalParams.loading}
                yesLabel = {modalParams.yesLabel ? modalParams.yesLabel : 'MODAL.YES_NO_CONFIRM_LABEL'}
                noLabel = {modalParams.noLabel ? modalParams.noLabel : 'MODAL.YES_NO_CANCEL_LABEL'}
                swapButtons = {modalParams.swapButtons}
                doNotShowCancel = {modalParams.doNotShowCancel}
            />
        </BaasicModal>
    );
}

BaasicConfirmModalTemplate.propTypes = {
    modalParams: PropTypes.object
}

export default defaultTemplate(BaasicConfirmModalTemplate);
